import './emailFloater.scss';

import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import CloseIcon from '../../assets/svg/close.svg';
import { AlmaLink } from '../alma-link';

export function EmailFloater({ emailFloater }) {
	const [emailCaptureStatus, setEmailCaptureStatus] = useState(false);
	const [emailCaptureClosed, setEmailCaptureClosed] = useState(false);
	const [cookiesEnabled, setCookiesEnabled] = useState(false);

	const scrollListener = () => {
		window.scrollY >= window.innerHeight - 100 &&
			setTimeout(() => {
				setEmailCaptureStatus(true);
			}, 0);
	};

	useEffect(() => {
		window.addEventListener('scroll', scrollListener);
		return () => {
			window.removeEventListener('scroll', scrollListener);
		};
	}, []);

	useEffect(() => {
		// check if cookies are enabled
		let cookieEnabled = navigator.cookieEnabled;
		if (!cookieEnabled) {
			document.cookie = 'testcookie';
			cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
		}

		if (cookieEnabled) {
			const emailPopupPreviouslyClosed =
				sessionStorage.getItem('email-popup-closed') === 'true';

			setCookiesEnabled(cookieEnabled);
			setEmailCaptureClosed(emailPopupPreviouslyClosed);
		}
	}, []);

	const handleEmailContainerClick = () => {
		if (cookiesEnabled) {
			sessionStorage.setItem('email-popup-closed', 'true');
		}
		setEmailCaptureStatus(false);
		setEmailCaptureClosed(true);
	};

	return (
		<div
			id='emailFloater'
			className={classNames(
				emailCaptureStatus && !emailCaptureClosed && 'open',
				'z-[600] p15 f aic x',
				emailFloater?.textColor && emailFloater.textcolor,
				emailFloater?.backgroundColor &&
					`b${emailFloater.backgroundColor}`
			)}
		>
			<div className='rel inner f x top'>
				<div
					className='close-icon abs right pointer z1 f'
					onClick={() => handleEmailContainerClick()}
					tabIndex={0}
					role='button'
				>
					<img src={CloseIcon} className='x' alt='Close Icon' />
				</div>
				<div className='text-container x y fill f fdc jcc'>
					{emailFloater?.header && (
						<p className='pb05'>{emailFloater.header}</p>
					)}
					{emailFloater?.subheader && (
						<p className='pb05'>{emailFloater.subheader}</p>
					)}
					{emailFloater?.cta && <AlmaLink cta={emailFloater.cta} />}
				</div>
			</div>
		</div>
	);
}
